import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function NavbarDashboard() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <nav className="navbar">
      <a href="#" className="sidebar-toggler">
        <i data-feather="menu" />
      </a>
      <div className="navbar-content">
        <form className="search-form w-25">
          <div className="input-group">
            <div className="input-group-text">
              <i data-feather="search" />
            </div>
            <input
              type="text"
              className="form-control"
              id="navbarForm"
              placeholder="Search here..."
            />
          </div>
        </form>
        <ul className="navbar-nav">
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="profileDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {user?.first_name} {user?.last_name}{"  "}
              <img
                className="wd-30 ht-30 rounded-circle"
                src="../images/reviewer/1.jpg"
                alt="profile"
              />
            </a>
            <div
              className="dropdown-menu p-0"
              aria-labelledby="profileDropdown"
            >
              <div className="d-flex flex-column align-items-center border-bottom px-5 py-3">
                <div className="mb-3">
                  <img
                    className="wd-80 ht-80 rounded-circle"
                    src="../images/reviewer/1.jpg"
                    alt=""
                  />
                </div>
                <div className="text-center">
                  <p className="tx-16 fw-bolder">
                    {user?.first_name} {user?.last_name}
                  </p>
                  <p className="tx-12 text-muted">{user?.email}</p>
                </div>
              </div>
              <ul className="list-unstyled p-1">
                <li className="dropdown-item py-2">
                  <Link to="/dashboard/profile" className="text-body ms-0">
                    <i className="me-2 icon-md" data-feather="user" />
                    <span>Profile</span>
                  </Link>
                </li>
                <li className="dropdown-item py-2">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLogout();
                    }}
                    className="text-body ms-0"
                  >
                    <i className="me-2 icon-md" data-feather="log-out" />
                    <span>Log Out</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
}
